<!-- filepath: /Users/desarrollo/Documents/Proyectos/friax/src/App.vue -->
<template>
  <div id="app" class="content">
    <router-view />
  </div>
</template>

<script>
import Header from './components/default/Header.vue';
import Footer from './components/default/Footer.vue';

export default {
  name: 'App',
  components: {
    Header,
    Footer
  }
}
</script>

<style>
/* Agrega estilos globales aquí */
.content {
  /* min-height: calc(100vh - 112px); */
  /* Altura total menos header y footer */
}
</style>